import useTranslation from 'next-translate/useTranslation';
import { Box } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

import SelectFieldOptions from '../../common/SelectFieldOptions';
import type { FieldOption, MockField } from '../utils/createFieldOptions';

interface CustomDeadlineOptionsProps {
  dayField: MockField;
  hourField: MockField;
  dayFieldOptions: FieldOption[];
  hourFieldOptions: FieldOption[];
  customDayValue: number | null;
  customHourValue: number | null;
  onDayChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onHourChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function CustomDeadlineOptions({
  dayField,
  hourField,
  dayFieldOptions,
  hourFieldOptions,
  customDayValue,
  customHourValue,
  onDayChange,
  onHourChange,
}: CustomDeadlineOptionsProps) {
  const { t } = useTranslation('contest');
  return (
    <>
      <div>
        <Text c="gray2.3" ta="center" variant="body-medium">
          {t('manage.common.fields.selectModalFieldWithCustom.selectDay')}
        </Text>
        <Box /* eslint-disable-line local-rules/use-theme-tokens */ mt={4}>
          <SelectFieldOptions
            field={dayField}
            options={dayFieldOptions}
            value={customDayValue}
            onChange={onDayChange}
          />
        </Box>
      </div>

      <div>
        <Text c="gray2.3" ta="center" variant="body-medium">
          {t('manage.common.fields.selectModalFieldWithCustom.selectTime')}
        </Text>
        <Box /* eslint-disable-line local-rules/use-theme-tokens */ mt={4}>
          <SelectFieldOptions
            field={hourField}
            options={hourFieldOptions}
            value={customHourValue}
            onChange={onHourChange}
          />
        </Box>
      </div>
    </>
  );
}
